import { memo } from "react";

import { Chart } from "primereact/chart";

import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

export const GraficoBalanceamento = memo(function GraficoBalanceamento({ chartId, chartType, chartData, fontSize = 20, goal, printing }) {
    const options = {
        maintainAspectRatio: false, 
        plugins: {
            title: {
                display: true,
                text: 'Balanceamento de Produção',
                font: {
                    size: 18
                }
            },
            annotation: {
                annotations: {
                    line1: {
                        type: "line",
                        yMin: goal !== null ? goal : 0,
                        yMax: goal !== null ? goal : 0,
                        borderColor: "#c0392b",
                        borderWidth: 2,
                    },
                },
            },
            datalabels: {
                anchor: 'end',
                align: 'end',
                rotation: '-90',
                formatter: (value) => {
                    return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(value);
                },
                font: {
                    size: fontSize
                },
                color: "#000"
            },
            scales: {
                x: {
                    stacked: true
                },
                y: {
                    stacked: true
                }
            }
        },
    }

    return (
        <Chart
            id={chartId}
            height={printing ? "210mm" :"850px"}
            width={printing ? "297mm" :"auto"}
            type={chartType}
            data={chartData}
            plugins={[ChartDataLabels, annotationPlugin]}
            options={options}
        />
    )
});